import { useEffect, useState } from "react";
import { Layout } from "@/components/Layout";
import { api, API_BASE } from "@/lib/api";
import { ShoppingBag, Star, ChevronRight } from "lucide-react";
import { toast } from "sonner";

export default function Storefront() {
  const [products, setProducts] = useState([]);
  const [cart, setCart] = useState({});

  useEffect(() => { api.get("/products").then((r) => setProducts(r.data)).catch(() => {}); }, []);

  const add = (p) => {
    setCart((c) => ({ ...c, [p.id]: (c[p.id] || 0) + 1 }));
    toast.success(`${p.name} secured in vault`);
  };
  const totalItems = Object.values(cart).reduce((a, b) => a + b, 0);
  const totalPrice = products.reduce((sum, p) => sum + (cart[p.id] || 0) * p.price, 0);

  return (
    <Layout>
      <section className="relative py-24 px-6 md:px-12 lg:px-20">
        <div className="max-w-7xl mx-auto">
          <span className="label-gold">Module 01 · Commerce</span>
          <h1 className="text-5xl md:text-7xl font-black uppercase tracking-tighter text-white mt-3">
            The Glow <span className="gold-shimmer">Storefront</span>.
          </h1>
          <p className="text-white/60 mt-6 max-w-2xl">
            Private-label products forged on the EIGOO Standard. Curated for the Pacific climate, engineered for the algorithm.
          </p>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
            {products.map((p) => (
              <article key={p.id} className="group relative" data-testid={`product-card-${p.id}`}>
                <div className="relative aspect-[4/5] overflow-hidden border border-[#C9A227]/15 group-hover:border-[#C9A227]/60 transition-all">
                  <img src={p.image} alt={p.name} className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-700"/>
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent opacity-80"/>
                  {p.best_seller && (
                    <span className="absolute top-4 left-4 bg-[#C9A227] text-black text-[10px] tracking-[0.2em] font-black uppercase px-2 py-1">
                      Best Seller
                    </span>
                  )}
                  <div className="absolute bottom-0 left-0 right-0 p-5">
                    <span className="text-[10px] tracking-[0.3em] uppercase text-[#C9A227] font-bold">{p.category}</span>
                    <h3 className="text-white text-xl font-black uppercase tracking-tight mt-1">{p.name}</h3>
                    <p className="text-white/60 text-xs mt-1 leading-relaxed">{p.tagline}</p>
                  </div>
                </div>
                <div className="mt-4 flex items-center justify-between">
                  <span className="text-2xl font-black gold-shimmer tabular-nums">${p.price.toFixed(2)}</span>
                  <button onClick={() => add(p)} className="btn-outline-gold text-[10px]" data-testid={`add-to-cart-${p.id}`}>
                    Secure +
                  </button>
                </div>
              </article>
            ))}
          </div>

          {totalItems > 0 && (
            <div className="fixed bottom-6 right-6 z-40 glass border border-[#C9A227] px-5 py-4 flex items-center gap-4">
              <ShoppingBag className="text-[#C9A227]"/>
              <div>
                <div className="text-white text-sm font-bold">{totalItems} items secured</div>
                <div className="text-[#C9A227] text-xs">${totalPrice.toFixed(2)} · checkout coming v1.1</div>
              </div>
            </div>
          )}
        </div>
      </section>
    </Layout>
  );
}
